import "./Manage2.css";
import Header from "./manage2/Header/Header";
import Login from "./Login/Login";
import Cookies from "js-cookie";

import { useState, useContext, createContext, useEffect } from "react";
import {Outlet} from "react-router-dom";

import { getTblList, useData } from "./consts.js";
import { handleLogout, regUses } from "./axios_with_token.js";

// import { useLogin } from "./Login/Login";
import LoginProvider, {useLoginContext} from "./Login/Login";


const Manage2Context = createContext({});
export const useManage2Data = ()=>useContext(Manage2Context);

function Content(props){
    const [_, refresh] = useState();
    const {regUse} = regUses();

    // const {LoginResult, Login, loggedin, setLoggedin, regSetLoggedin} = regUse(useLogin({
    //     // username: 'guest',
    //     // password: 'guest'
    //     username: 'martin',
    //     password: 'letmein',
    //     refresh: _=>refresh(Math.random())

    // }));
    const {loggedin, setLoggedin} = useLoginContext();
    const [tblName, setTblName] = useState()
    const [mode, setMode] = useState('summary')

    // [] set state must only be executed once using [], otherwise infinite loop
    useEffect(_=>{
        try{
            // console.log('cookies:', Cookies.get('loggedIn'), Cookies.get('userInfo'));
            // [] important to use parse, since loggedIn may be stored as string 'false'
            const loggedIn = JSON.parse(Cookies.get('loggedIn'));
            const userInfo = JSON.parse(Cookies.get('userInfo'));

            // if(!userInfo || !userInfo.user_name || userInfo.user_name == 'guest'){
            //     console.log('logging out');
            //     handleLogout().logout();
            // }

            // setLoggedIn(loggedIn);
            // setUserInfo(userInfo);
        }catch(err){
            console.log('[retrieve login status errror]', err);
        }

        // [] reg handle error call back
        // regCb(_=>{
        //     console.log('registered cb.');
        // })
    }, [])

    return <Manage2Context.Provider
        value={{
        }}
    >
        {/* {!token&&<Login setToken={setToken}/>} */}
        {/* {!loggedIn&&<Login />} */}

        {/* {loggedIn&&<>
            <Header setTblName={setTblName} setMode={setMode}/>
        </>} */}
        <Header setTblName={setTblName} setMode={setMode}/>
        <Outlet></Outlet>

    </Manage2Context.Provider>;
}

export default function Manage2({children}){
    return <LoginProvider>
        <Content>{children}</Content>
    </LoginProvider>;
}